// extracted by mini-css-extract-plugin
export default {"root":"SvgCanvas_root__5Ihqy","loading":"SvgCanvas_loading__h-WfG","loadingSpinner":"SvgCanvas_loadingSpinner__LSYFX","spin":"SvgCanvas_spin__AcxgG"};